<template>
  <app-comment class="mt-3" :src="student.avatar">
    <template #title>Your English Speech</template>
    <template #body>
      <v-card
        v-if="timeStamp"
        class="absolute py-4 px-3 timebox half-radius"
        :class="{ blinking: recording }"
        >{{ formatTime(timeStamp) }}</v-card
      >
      <app-button-player
        v-if="audioUrl || (answer && answer.audio_file)"
        :src="audioUrl ? audioUrl : answer.audio_file"
        :size="24"
        class="to-the-bottom"
        :class="{ commenting: commentDialog, fade: !commentDialog }"
      />
      <v-btn
        v-if="audioUrl || (answer && answer.audio_file)"
        text
        absolute
        bottom
        left
        class="text-capitalize body-2 custom-text"
        :loading="downloadingLoading"
        @click="downloadAudio"
      >
        <v-icon left>$vuetify.icons.appDownload</v-icon>
        <span class="mr-1" v-if="!$vuetify.breakpoint.xs">Download Audio</span>
      </v-btn>
      <v-btn
        v-if="!(answer && answer.audio_file)"
        text
        absolute
        left
        bottom
        class="text-capitalize body-2 custom-text mb-10"
        @click="uploadAudio"
      >
        <v-icon style="transform: rotateX(180deg)" left>$vuetify.icons.appDownload</v-icon>
        <span class="mr-1" v-if="!$vuetify.breakpoint.xs">Upload Audio</span>
      </v-btn>
      <v-row justify="center">
        <v-col class="text-center py-0" cols="12">
          <app-microphone @click="tryRecord" :recording="recording" />
        </v-col>
        <v-col class="text-center black--text" cols="12">{{
          recording ? "Click here to stop recording" : "Click to start recording"
        }}</v-col>
      </v-row>
      <confirm-dialog
        v-model="confirmDialogModel"
        :hideAccept="!!(answer && answer.audio_file)"
        @yes="onYes"
      >
        {{
          answer && answer.audio_file
            ? "Your speech is already saved, unable to record again"
            : "Are you sure you want to delete this voice file and record your speech again?"
        }}
        <template #acceptText> Record again </template>
        <template #cancelText>{{ answer && answer.audio_file ? "OK" : "Keep the file" }}</template>
      </confirm-dialog>
    </template>
  </app-comment>
</template>
<script>
import Comment from "./Comment";
import audioMixin from "@/mixins/audioMixin";
import ButtonPlayer from "./ButtonPlayer.vue";
import Microphone from "./Microphone.vue";
import { getAudio } from "@/api/api";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

export default {
  components: {
    appComment: Comment,
    appButtonPlayer: ButtonPlayer,
    appMicrophone: Microphone,
    ConfirmDialog,
  },
  mixins: [audioMixin],
  props: {
    answer: {
      required: false,
      default: () => {},
      type: Object,
    },
    commentDialog: Boolean,
  },
  data() {
    return {
      downloadingLoading: false,
      confirmDialogModel: false,
    };
  },
  computed: {
    playerIcon() {
      if (this.playing) return "mdi-stop";
      else return "$vuetify.icons.appSpeaker";
    },
    student() {
      if (this.$store.getters.profile.role === "STUDENT") {
        return this.$store.getters.profile;
      } else return this.$store.getters.student;
    },
  },
  methods: {
    tryRecord() {
      if (!this.recording && (this.audioUrl || (this.answer && this.answer.audio_file))) {
        this.confirmDialogModel = true;
      } else this.onRecord();
    },
    onYes() {
      this.onRecord();
      this.confirmDialogModel = false;
    },
    onClick() {
      if (!this.audioBlob) {
        this.audioUrl = this.answer.audio_file;
      }
      if (!this.playing) {
        this.audioPlay();
      } else {
        this.audioNoPlay();
      }
    },
    async downloadAudio() {
      try {
        this.downloadingLoading = true;
        let anchor = document.createElement("a");
        if (!this.audioBlob) {
          anchor.href = this.answer.audio_file;
        } else anchor.href = this.audioUrl;
        const item = await getAudio(anchor.href);
        anchor.href = URL.createObjectURL(new Blob([item.data]));
        anchor.target = "_blank";
        anchor.download = new Date().toISOString() + ".webm";
        anchor.click();
        this.downloadingLoading = false;
      } catch (error) {
        this.downloadingLoading = false;
        throw error;
      }
    },
    uploadAudio() {
      let fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "audio/*";
      fileInput.oninput = (e) => {
        this.audioUrl = URL.createObjectURL(e.target.files[0]);
        this.audioBlob = e.target.files[0];
        this.timeStamp = 0;
      };
      fileInput.click();
    },
  },
  watch: {
    answer: {
      handler(val) {
        if (!val || !val.audio_file) {
          this.timeStamp = 0;
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.timebox {
  font-size: 36px;
  background: #262626;
  color: white;
  right: 20px;
  top: 20px;
  line-height: 1.5rem;
}
.to-the-bottom {
  position: absolute;
  bottom: 20px;
  right: 30px;
}
.commenting {
  position: fixed;
  bottom: 1rem;
  right: 3rem;
  z-index: 250;
  animation: slideLeft 0.4s linear;
}

.fade {
  animation: fade 0.5s linear;
}

@keyframes slideLeft {
  0% {
    right: 50px;
    opacity: 0;
  }
  25% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.8);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
